module.exports = __webpack_public_path__ + "static/media/administratorline.90611533.svg";